export default __webpack_public_path__ + "static/media/AdminDemoImg.002134d3.png";